import {defineMessages, MessageDescriptor} from 'react-intl';

type SelectorMessagesKeys =
  | 'label'
  | 'error'
  | 'chooseLabel'
  | 'inputPlaceholder'
  | 'noResults'
  | 'searchError';

export const selectorMessages: Record<SelectorMessagesKeys, MessageDescriptor> =
  defineMessages({
    label: {
      id: 'support_conversations_client.topicSelector.label',
      description: 'Label for the support topic selector',
      defaultMessage: 'What can we help you with today?',
    },
    error: {
      id: 'support_conversations_client.topicSelector.error',
      description: 'Error shown for forms where the topic is required',
      defaultMessage: 'Please choose a topic.',
    },
    chooseLabel: {
      id: 'support_conversations_client.topicSelector.choose',
      description: 'Text shown in topic selector before user has made a choice',
      defaultMessage: 'Select a topic…',
    },
    inputPlaceholder: {
      id: 'support_conversations_client.topicSelector.search.inputPlaceholder',
      description: 'Placeholder text shown in topic selector search box',
      defaultMessage: 'Search…',
    },
    noResults: {
      id: 'support_conversations_client.topicSelector.search.noResultsFound',
      description:
        "Message shown in topic selector when the user's search resulted in no matches.",
      defaultMessage: 'No results found',
    },
    searchError: {
      id: 'support_conversations_client.topicSelector.search.error',
      description: 'Message shown in topic selector when there is an error.',
      defaultMessage: 'There was an error retrieving the results.',
    },
  });
